import React from 'react';
import './styles.css';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import {
  sendClevertapTrackerOnClickActivatePaymentMethodNotification,
  sendClevertapTrackerOnClickDismissPaymentMethodNotification,
} from 'actions/setting/paymentMethod';
import withFeatureFlags from 'hocs/withFeatureFlags';
import wallet from './wallet.png';
import logo from './moka-logo-white.png';

class EWalletNotification extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNotification: true,
    };
  }

  onClickDismiss = () => {
    this.props.dispatch(
      sendClevertapTrackerOnClickDismissPaymentMethodNotification()
    );
    this.setState(state => ({
      showNotification: !state.showNotification,
    }));
  };

  onClickActivate = () => {
    this.props.dispatch(
      sendClevertapTrackerOnClickActivatePaymentMethodNotification()
    );
  };

  render() {
    const { kybNewContent } = this.props;
    return (
      <div
        className={`row alert alert-info text-left ewallet-notification-container ${
          this.state.showNotification ? 'show' : 'hide'
        }`}
      >
        <div className="col-md-1">
          {!kybNewContent && <img src={wallet} />}
          {kybNewContent && <img src={logo} />}
        </div>
        {!kybNewContent && (
          <div className="col-md-8">
            <p className="notification-text-header">
              Activate your mobile payment method and enjoy various benefit from
              our partners
            </p>
            <p className="notification-text">
              Start accepting any mobile payment seamlessly and securely through
              Moka. Run your business without worry through integrated reporting
              and enjoy the benefit of various marketing campaigns from our
              payment partners
            </p>
          </div>
        )}
        {kybNewContent && (
          <div className="col-md-8">
            <p className="notification-text-header">
              Before you get started on your store, we just need a few last
              details so you can start using our products.
            </p>
          </div>
        )}

        <div className="col-md-2">
          {!kybNewContent && (
            <Link to="/settings/payment_methods">
              <a
                className="btn btn-success btn-lg btn-activate-now"
                onClick={this.onClickActivate}
              >
                Activate Now
              </a>
            </Link>
          )}
          {kybNewContent && (
            <Link to="/kyb">
              <a
                className="btn btn-success btn-lg btn-activate-now"
                onClick={this.onClickActivate}
              >
                Complete Your Identity
              </a>
            </Link>
          )}
        </div>
        <div className="col-md-1">
          <span className="close-notification" onClick={this.onClickDismiss}>
            {' '}
            &times;{' '}
          </span>
        </div>
      </div>
    );
  }
}

function mapFeatureFlags(flags) {
  return {
    kybNewContent: flags.kybNewContent,
  };
}

export default withFeatureFlags(mapFeatureFlags)(
  connect()(EWalletNotification)
);
